import {
  NEW_PASSWORD,
  NEW_PASSWORD_CONFIRM,
  NEW_PASSWORD_CONFIRM_IS_VALID,
  NEW_PASSWORD_IS_VALID,
  PASSWORD_RESETTED_SUCCESSFULLY,
  propertyChange,
  requestPasswordReset,
  resetPassword,
  TOKEN_INVALID,
  USERNAME,
  validateToken
} from "../../../ducks/forgotPassword";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { LANGUAGE } from "../../../ducks/languageSelector";
import PasswordTokenReset from "./PasswordTokenReset";
import { clearMessages } from "../../../ducks/message";
import { FORGOT_PASSWORD_STORE, LANGUAGE_SELECTOR } from "../../../common/constant";

const mapStateToProps = (state) => {
  return {
    locale: state[LANGUAGE_SELECTOR][LANGUAGE],
    username: state[FORGOT_PASSWORD_STORE][USERNAME],
    newPassword: state[FORGOT_PASSWORD_STORE][NEW_PASSWORD],
    newPasswordConfirm: state[FORGOT_PASSWORD_STORE][NEW_PASSWORD_CONFIRM],
    newPasswordIsValid: state[FORGOT_PASSWORD_STORE][NEW_PASSWORD_IS_VALID],
    newPasswordConfirmIsValid: state[FORGOT_PASSWORD_STORE][NEW_PASSWORD_CONFIRM_IS_VALID],
    tokenInvalid: state[FORGOT_PASSWORD_STORE][TOKEN_INVALID],
    passwordResettedSuccessfully: state[FORGOT_PASSWORD_STORE][PASSWORD_RESETTED_SUCCESSFULLY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      propertyChange,
      requestPasswordReset,
      validateToken,
      resetPassword,
      clearMessages
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordTokenReset);
